import { createContext, useContext, useState, ReactNode } from 'react';
import { ThemeId, normalizeThemeId } from '../themes';

/**
 * Contexte partagé entre les sous-onglets Synthèse (Pilotage/Présentation/Composition).
 * Le THÈME est partagé : changer Ivory dans Composition bascule aussi Présentation.
 * L'ORIENTATION reste locale à chaque onglet (peut vouloir portrait en comp, paysage en prés).
 */
type SyntheseState = {
  theme: ThemeId;
  setTheme: (t: ThemeId) => void;
};

const SyntheseContext = createContext<SyntheseState | null>(null);

export function SyntheseProvider({
  children,
  defaultTheme = 'corporate',
}: {
  children: ReactNode;
  defaultTheme?: ThemeId;
}) {
  const [theme, setThemeState] = useState<ThemeId>(normalizeThemeId(defaultTheme));
  const setTheme = (t: ThemeId) => setThemeState(normalizeThemeId(t));
  return (
    <SyntheseContext.Provider value={{ theme, setTheme }}>{children}</SyntheseContext.Provider>
  );
}

export function useSyntheseTheme(): SyntheseState {
  // On appelle TOUJOURS les deux hooks pour respecter les règles de React.
  // Si le provider est présent, ctx gagne ; sinon on utilise le state local.
  const ctx = useContext(SyntheseContext);
  const [localTheme, setLocalTheme] = useState<ThemeId>('corporate');
  if (ctx) return ctx;
  return { theme: localTheme, setTheme: (t: ThemeId) => setLocalTheme(normalizeThemeId(t)) };
}
